export default "__VITE_ASSET__30cca31a__"